import { render, staticRenderFns } from "./useraccount.vue?vue&type=template&id=1a5889fd&"
import script from "./useraccount.vue?vue&type=script&lang=js&"
export * from "./useraccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports